import { InvoicingSettingsSection } from '../../../enums/invoicingSettingsSection'

// Sections whose settings save themselves and never register a form with the host. The modal hides
// the footer Save button for them: there is nothing to save from the footer.
const selfSavingInvoicingSettingsSections: ReadonlySet<InvoicingSettingsSection> = new Set([
  InvoicingSettingsSection.EInvoicing,
])

export const isSelfSavingInvoicingSettingsSection = (section: InvoicingSettingsSection): boolean =>
  selfSavingInvoicingSettingsSections.has(section)
